<obg-m-dialog-layout
	#dialog
	[dialogId]="'kyc-method-selection-dialog'"
	hideClose
	[hideFooter]="true"
	test-id="kyc-method-selection-dialog"
>
	<obg-m-kyc-method-selection test-id="kyc-method-selection-frame"></obg-m-kyc-method-selection>
</obg-m-dialog-layout>
